export type HubSpotContactFormData = {
  name: string;
  email: string;
  phone: string;
};

export type HubSpotFormField = {
  name: string;
  value: string;
};

export type HubSpotFormContext = {
  hutk?: string;
  pageUri: string;
  pageName: string;
};

export type HubSpotFormSubmissionRequest = {
  fields: HubSpotFormField[];
  context: HubSpotFormContext;
};

export type HubSpotFormSubmissionResponse = {
  inlineMessage?: string;
  errors?: Array<{
    message: string;
    errorType: string;
  }>;
};

